import { render, staticRenderFns } from "./RelatorioProcessos.vue?vue&type=template&id=5f5cad6d&scoped=true&"
import script from "./RelatorioProcessos.vue?vue&type=script&lang=js&"
export * from "./RelatorioProcessos.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioProcessos.vue?vue&type=style&index=0&id=5f5cad6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5cad6d",
  null
  
)

export default component.exports